module.exports = __webpack_public_path__ + "static/bg-nsd-a3edf377ad8789839917d47004e0f8ec.webp";